import { ModelSagresDatatable } from "@/types/model-sagres-datatable";
import { ItemLicitacao } from "./item-licitacao";
import { ParticipanteLicitacao } from "./participante-licitacao";

export class LicitacaoVencedorLote extends ModelSagresDatatable {
  NuSequencialLote: number;
  DeLote: string;
  FlFracassado: string; //'S' ou 'N'
  NmParticipante: string;
  DtHomologacaoLote?: Date;
  VlTotalLicitado: number;

  //adicionados em 20230706
  IdLoteLicitacao: number;
  IdLicitacao: number;
  IdParticipanteLicitacaoNavigation: ParticipanteLicitacao;
  VlTotalEstimado: number;
  QtdItens: number;
  ItemLoteLicitacao: ItemLicitacao[];

  //transient usado para editar participante vencedor
  participanteVencedor: number;

  //TO-DO: Centralizar estes tratamentos no ModelSagres. Dá pra loopar o obj e tratar todas as datas.
  //também dá pra criar enums para estas strings sim/nao, ativo/inativo etc
  tratarDadosDaAPI(): void {
    if (this.DtHomologacaoLote) {
      this.DtHomologacaoLote = new Date(this.DtHomologacaoLote);
    }
    if (this.FlFracassado) {
      this.FlFracassado = this.FlFracassado === "S" ? "Sim" : "Não";
    }
  }
}
